var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-row',[_c('van-divider'),_c('van-col',{attrs:{"span":"9","offset":"1"}},[_c('span',[_vm._v("明细占比:"+_vm._s(_vm.sortName))])])],1),_c('van-row',[_c('canvas',{attrs:{"id":_vm.viewId}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }